import React from "react";
import { Col, Row } from "react-bootstrap";
import "../../Assets/Styles/pages/landing.scss";
import featuresBanner from "../../Assets/Images/featuresBanner.png";
import { useTranslation } from "react-i18next";

const Banner = () => {
  const { t } = useTranslation();

  return (
    <Row className="m-0 w-100 pt-3 mt-5 d-flex justify-content-center align-items-center ">
      <Col className="d-flex flex-column align-items-center justify-content-center">
        <Col
          lg={6}
          className="d-flex flex-column align-items-center justify-content-center"
        >
          <Row className="m-0 w-100 px-4  text-center p-0 productSansBold text_40">
            <Col className="p-0 line_height_3">
              {t("FeatureBanner1")}
              <span className="productSansBold landing_banner_Heading mx-2">
                {t("FeatureBannerSpan")}
              </span>
              {t("FeatureBanner2")}
            </Col>
          </Row>
        </Col>
        <Col lg={6}>
          <Row className="d-flex justify-content-center text-black m-0 px-4 text-black text-center p-0 productSansLight text_18">
            <Col lg={9} className="px-0 pb-1 mb-2">
              {t("FeatureBannerSubTitle")}
            </Col>
          </Row>
        </Col>
        <Row>
          <Col>
            <img alt="feature banner" className="w-100" src={featuresBanner} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Banner;
